import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store/store";
import { Meal_Plan, MealNote, NutritionalTarget } from "../../components/mealPlanPage/mealPlan.types";
import { isJsonString } from "../../components/newHomePage/utils/newHomePageUtils";

interface MealPlanData {
  user_id: string;
  meal_plan_id: string;
  Meal_Plan: Meal_Plan;
}

interface nutritionalTargetData {
  id: string;
  start_date: string;
  end_date: string;
  nutritional_target: NutritionalTarget;
}

interface InitialState {
  selectedDate: Date;
  selectedMealType: string | null;
  userMealPlanData: MealPlanData | null;
  mealNotes: MealNote[];
  nutritionalTarget: nutritionalTargetData | null
}

const mealPlanData = localStorage.getItem('mealPlanData');


const initialState: InitialState = {
  selectedDate: new Date(),
  selectedMealType: null,
  userMealPlanData: mealPlanData && isJsonString(mealPlanData) ? JSON.parse(mealPlanData) : null,
  mealNotes: [],
  nutritionalTarget: null
};

export const createMealPlanSlice = createSlice({
  name: "mealPlan",
  initialState,
  reducers: {
    setSelectedDate: (state, action: PayloadAction<Date>) => {
      state.selectedDate = action.payload;
    },
    setSelectedMealType: (state, action: PayloadAction<string>) => {
      state.selectedMealType = action.payload;
    },
    setuserMealPlanData: (state, action: PayloadAction<MealPlanData>) => {
      state.userMealPlanData = action.payload;
    },
    setMealNotes: (state, action: PayloadAction<MealNote[]>) => {
      if (Array.isArray(action.payload)) {
        state.mealNotes = action.payload;
      }
    },
    setNutritionalTarget: (state, action: PayloadAction<nutritionalTargetData>) => {
      state.nutritionalTarget = action.payload;
    },

  },

});


export const { setSelectedDate, setSelectedMealType, setuserMealPlanData, setMealNotes, setNutritionalTarget } = createMealPlanSlice.actions;

export const SelectedDateSelector = ((state: RootState) => state.mealPlan.selectedDate);
export const SelectedMealTypeSelector = ((state: RootState) => state.mealPlan.selectedMealType);
export const UserMealPlanDataSelector = ((state: RootState) => state.mealPlan.userMealPlanData);
export const MealNotesSelector = ((state: RootState) => state.mealPlan.mealNotes);
export const NutritionalTargetSelector = ((state: RootState) => state.mealPlan.nutritionalTarget);

export default createMealPlanSlice.reducer;